import { ClientGalleryPageActionsController } from './ClientGalleryPageActions.controller'
import { FC } from 'react'
import { RescheduleOrderModuleProvider } from 'components/common/RescheduleOrder'
import { useGalleryDeal } from '../../contexts'

/**
 * Client gallery page actions.
 * 
 * @example <ClientGalleryPageActions />
 */
export const ClientGalleryPageActions: FC = () => {
  const { dealData } = useGalleryDeal()

  return (
    <RescheduleOrderModuleProvider orderId={dealData?.id}>
      <ClientGalleryPageActionsController />
    </RescheduleOrderModuleProvider>
  )
}
